import toast from "react-hot-toast";

// Utility function to set a default duration for all your toasts
const TOAST_OPTIONS = {
  duration: 3000,
};

export const showSuccess = (msg, duration = TOAST_OPTIONS.duration) =>
  toast.success(msg, { duration });

export const showError = (msg, duration = TOAST_OPTIONS.duration) =>
  toast.error(msg, { duration });
